// kycSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_KYB_DETAIL_REQUEST } from "../types";
import {
  fetchKybDetailSuccess,
  fetchKybDetailFailure,
} from "../actions/kybActions";
import axios from "axios";
import { DGTL_BACKEND_URL } from "../URL";

function* fetchKybDetail(action) {
  console.log("action", action);
  const kybId = action.payload; // Extract kycId from the action payload
  const type = action.type;
  try {
    const token =
      window.location.href.split("/")[5]?.split("&")[0] ||
      localStorage.getItem("token"); // Adjust as needed

    let body = {
      id: kybId, // Use kycId in the request body
      type: type,
    };
    const response = yield call(
      axios.post,
      `${DGTL_BACKEND_URL}/admin/kyb/getCorporateClientDetails`,
      body,
      {
        headers: { Authorization: `Bearer ${token}` },
      } // Use kycId in the API call
    );
    const { data } = response.data;
    console.log("dataReq", data);
    yield put(fetchKybDetailSuccess(data));
  } catch (error) {
    console.log("error", error);
    yield put(fetchKybDetailFailure(error.message));
  }
}

function* kybSaga() {
  yield takeLatest(FETCH_KYB_DETAIL_REQUEST, fetchKybDetail);
}

export default kybSaga;
